import React from 'react'
import { SkeletonLoader } from '@core/Areas/BetLoop/Components/Common/SkeletonLoader'
import { SharedBetCard } from '@core/Areas/BetLoop/Components/Common/SharedBetCard'
import { EmptyMessage } from '@core/Areas/BetLoop/Components/Common/EmptyMessage'
import { useCopiedBetsData } from '@core/Areas/BetLoop/hooks/useCopiedBetsData'

export const MyCopiedBets: React.FC<{
  setHasCopiedBets(hasBets: boolean): void
  isUsingScrollRestore: boolean
}> = ({ setHasCopiedBets, isUsingScrollRestore }) => {
  const { isLoading, data, isRefetching, LoadMoreButton } = useCopiedBetsData()

  const hasCopiedBets = data?.pages.flat().filter(Boolean).length !== 0

  React.useEffect(() => {
    if (hasCopiedBets) setHasCopiedBets(true)
  }, [hasCopiedBets, setHasCopiedBets])

  const shouldDisplayPreviousData = isUsingScrollRestore && Boolean(data?.pages)
  if (!shouldDisplayPreviousData && (isLoading || isRefetching || !data)) return <SkeletonLoader />

  if (data && (data.pages.length === 0 || data.pages[0].length === 0)) {
    return (
      <EmptyMessage
        messageType='non-bettable-tip'
        title='No Copied Bets'
        description="You haven't copied any bets yet – head to Bet Loop to copy your first!"
      />
    )
  }

  const copiedBetsData = data?.pages.flat()

  return (
    <>
      {copiedBetsData?.map(sharedBet => (
        <SharedBetCard
          key={`${sharedBet.postId}.${sharedBet.ownerAccountId}`}
          sharedBet={sharedBet}
          isMyCopiedBet
        />
      ))}

      <LoadMoreButton />
    </>
  )
}
